export { ImageWithFocalPoint } from './ImageWithFocalPoint';
